'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgArrowContract = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M12.243 10.9 8 6.656V3.828l3.246 3.246L11.238 2h2.009l-.007 5.074 3.245-3.246v2.829l-4.242 4.242ZM12.243 13 8 17.243v2.828l3.246-3.246-.008 5.075h2.009l-.007-5.075 3.245 3.246v-2.828L12.243 13Z" })
);

module.exports = SvgArrowContract;
//# sourceMappingURL=ArrowContract.cjs.js.map
